import React from 'react';
export function TruthSection() {
  return <section className="w-full bg-white py-20 px-6 md:px-8 border-y border-lavender/20 pt-[50px] pb-[50px]" data-id="element-331">
      <div className="max-w-4xl mx-auto" data-id="element-332">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-333">
          <span className="text-rose-DEFAULT font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-334">
            La verdad incómoda
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text mb-4" data-id="element-335">
            No te falta actitud.
            <br data-id="element-336" />
            <span className="text-lavender-dark" data-id="element-337">Te falta estructura.</span>
          </h2>
        </div>

        {/* Copy */}
        <div className="max-w-3xl mx-auto space-y-6 text-lg leading-relaxed text-text/80 mb-10" data-id="element-338">
          <p className="text-[22px]" data-id="element-339">
            Porque el posparto tiene una trampa: cuando más necesitas claridad,
            menos capacidad tienes para decidir.
          </p>

          <p className="font-semibold text-text text-[24px]" data-id="element-340">
            Y ahí es donde todo se rompe:
          </p>

          <ul className="space-y-3 pl-2" data-id="element-341">
            {['Abres TikTok/Instagram y guardas 40 videos que nunca vuelves a ver', 'Googleas a las 2am y terminas peor que antes', 'Te compras un libro y no pasas de la página 6', 'Alguien te dice "duerme cuando el bebé duerma" y te dan ganas de gritar'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-342">
                <span className="text-lavender-dark font-bold flex-shrink-0" data-id="element-343">
                  •
                </span>
                <span className="text-[22px]" data-id="element-344">{item}</span>
              </li>)}
          </ul>

          <div className="mt-8 p-6 bg-rose-light/30 rounded-2xl border border-rose-DEFAULT/20" data-id="element-345">
            <p className="font-semibold text-text italic text-[24px] pl-[0px] pr-[0px] ml-[0px] mr-[0px]" data-id="element-346">
              No porque seas dramática. Porque estás en supervivencia.
            </p>
          </div>

          <p className="text-xl font-bold text-lavender-dark pt-4" data-id="element-347">
            Y en supervivencia, no necesitas más información. Necesitas que
            alguien ya haya decidido por ti.
          </p>
        </div>

        {/* Image */}
        <div className="relative w-full max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-2xl" data-id="element-348">
          <img src="https://cdn.magicpatterns.com/uploads/mwG2ctqcQEgge8wmKfCHrg/heylloyd-image-1770269856047.png" alt="Mamá con bebé usando el Plan de Supervivencia Postparto" className="w-full h-auto object-cover" data-id="element-349" />
        </div>
      </div>
    </section>;
}